// Click-to-enlarge for the "What it actually does" panel.
//
// The diagram carries six callouts of small print, so at accordion width it is a thumbnail you
// squint at. It now sits small by default with a line of copy above it, and opens full-screen on
// click — then returns to the thumbnail on close.
//
// No library. Delegated click, so it also covers images injected after load.
(function () {
  var box, img, open = false;

  function build() {
    box = document.createElement('div');
    box.className = 'bblb';
    box.setAttribute('role', 'dialog');
    box.setAttribute('aria-modal', 'true');
    box.setAttribute('aria-label', 'Enlarged product diagram');
    box.innerHTML =
      '<button class="bblb__x" type="button" aria-label="Close">&times;</button>' +
      '<img alt="">';
    img = box.querySelector('img');
    box.addEventListener('click', function (e) {
      if (e.target === box || e.target.classList.contains('bblb__x')) close();
    });
    document.body.appendChild(box);
  }

  function show(src, alt) {
    if (!box) build();
    img.src = src;
    img.alt = alt || '';
    box.setAttribute('data-open', '');
    document.documentElement.style.overflow = 'hidden';
    open = true;
    box.querySelector('.bblb__x').focus();
  }

  function close() {
    if (!open) return;
    box.removeAttribute('data-open');
    document.documentElement.style.overflow = '';
    open = false;
  }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('.bbzoom');
    if (!t) return;
    e.preventDefault();
    // full-resolution source, not the thumbnail Shopify served
    show(t.getAttribute('data-full') || t.currentSrc || t.src, t.alt);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') close();
  });
})();